import React from 'react';

const SvgCourseHoursTotal = props => (
  <svg data-name="Layer 1" viewBox="0 0 28.29 28.29" {...props}>
    <path d="M14.15 0A14.15 14.15 0 1028.3 14.15 14.16 14.16 0 0014.15 0zm0 26.79a12.65 12.65 0 1112.6-12.64 12.66 12.66 0 01-12.6 12.65z" />
    <path d="M15.96 13.4l6.38-6.38-1.07-1.06-6.37 6.38V3.32h-1.5v9.02L7.02 5.96 5.96 7.02l6.38 6.38H3.32v1.5h9.02l-6.38 6.37 1.06 1.07 6.38-6.38v9.02h1.5v-9.02l6.37 6.38 1.07-1.07-6.38-6.37h9.02v-1.5h-9.02z" />
  </svg>
);

export default SvgCourseHoursTotal;
